function calculatePriceAfterDiscount(price, discount, discountType) {
  if (discountType?.toLowerCase() === 'percent') {
    return Math.max(0, price * (1 - discount / 100));
  } else if (discountType?.toLowerCase() === 'fixed') {
    return Math.max(0, price - discount);
  }
  return price;
}

export { calculatePriceAfterDiscount };
